import { render, staticRenderFns } from "./IsActive.vue?vue&type=template&id=37fc79a1&"
import script from "./IsActive.vue?vue&type=script&lang=js&"
export * from "./IsActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports